// extracted by mini-css-extract-plugin
export default {"backofficeWidget":"backofficeWidget_LHcSv7r","backofficeWidget__heading":"backofficeWidget__heading_ASTR8hW"};